<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

<div class="search-container">
<button @click="goToSpesa" class="create-user-button staff-button-positive"><span class="material-icons">add_circle_outline</span> Crea una spesa</button>
<button @click="exportToCSV" class="create-user-button staff-button-neutral"><span class="material-icons">download</span> Export.csv</button>

</div>
      <div class="columns-container">
        <!-- Colonna Sinistra: Lista Ordini -->
        <div class="column left-column">
          <h3>Ordini dell'Utente</h3>

<!-- Filtro per Data -->
<div class="filter-container">
  <label for="startDate">Da:</label>
  <input type="date" id="startDate" v-model="filtroData.inizio" />

  <label for="endDate">A:</label>
  <input type="date" id="endDate" v-model="filtroData.fine" />

  <button @click="filtraOrdini" class="filter-button staff-button-neutral">Cerca</button>
</div>




<!-- Tabella Ordini -->
<table class="orders-table">
  <thead>
    <tr>
      <th>Cliente</th>
      <th>Costo (€)</th>
      <th>Pagato (€)</th>
      <th>Data</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="order in filteredOrders" :key="order.id">
      <td>{{ order.customer_name }} {{ order.customer_surname }}</td>
      <td>{{ order.total_without_discount ? parseFloat(order.total_without_discount).toFixed(2) : 'N/A' }}</td>
      <td>{{ order.total_with_discount ? parseFloat(order.total_with_discount).toFixed(2) : 'N/A' }}</td>
      <td>{{ formatDate(order.created_at) }}</td>
    </tr>
  </tbody>
</table>

        </div>

        <!-- Colonna Destra: Modulo per Creare Ordine -->
        <div class="column right-column">
          <button @click="addNewProducts" class="create-user-button staff-button-positive">
  <span class="material-icons">playlist_add</span>
  Aggiungi Prodotti su Firebase
</button>

<button @click="syncProducts" class="create-user-button staff-button-neutral">
  <span class="material-icons">sync</span>
  Sincronizza Prodotti
</button>

          <h3>Crea Nuovo Ordine</h3>
          <div class="search-container">
            <input
              type="email"
              v-model="searchEmail"
              placeholder="Cerca cliente per email..."
              class="search-bar"
            />
            <button @click="fetchUserByEmail" class="create-user-button staff-button-neutral">
              <span class="material-icons">search</span>
              Cerca
            </button>
          </div>

          <div v-if="userFound" class="data-section">
            <h4>Dati Cliente</h4>
          <p><strong>Nome:</strong> {{ orderData.customer_name }}</p>
      <p><strong>Cognome:</strong> {{ orderData.customer_surname }}</p>
      <p><strong>Email:</strong> {{ orderData.email }}</p>
      <p><strong>Telefono:</strong> {{ orderData.phone }}</p>
      <p><strong>Codice Fiscale:</strong> {{ orderData.codFiscale }}</p>
      <p><strong>Indirizzo:</strong> {{ orderData.indirizzo }}</p>
      <p><strong>CAP:</strong> {{ orderData.cap }}</p>
      <p><strong>Comune:</strong> {{ orderData.comune }}</p>
      <p><strong>Regione:</strong> {{ orderData.regione }}</p>
      <p><strong>Provincia:</strong> {{ orderData.provincia }}</p>
      <p><strong>Studio:</strong> {{ orderData.studio }}</p>
      <p><strong>Note:</strong> {{ orderData.notes }}</p>
          </div>
          <div v-for="(product, index) in orderData.products" :key="index" class="product-section">
  <label for="searchProduct">Prodotto {{ index + 1 }}</label>
  <input
    type="text"
    v-model="product.search"
    placeholder="Cerca prodotto..."
    class="search-bar"
    @input="filterProducts(index)"
  />
  <div class="product-row">
    <select v-model="product.product_id" class="user-input product-select">
      <option v-for="prod in product.filteredProducts" :key="prod.id" :value="prod.id">
        {{ prod.name }} - {{ prod.price }} €
      </option>
    </select>

    <div class="quantity-container">
      <label><h5>Quantità:</h5></label>
      <input type="number" v-model="product.quantity" class="user-input product-quantity" />
    </div>
  </div>
</div>

<!-- Bottone Aggiungi Prodotto fuori dal ciclo -->
<button @click="addProduct" class="create-user-button staff-button-positive">
  <span class="material-icons">add</span>
  Aggiungi Prodotto
</button>


          <div class="totals-section">
  <label for="discount">Sconto (€):</label>
  <input
    type="number"
    id="discount"
    v-model.number="orderData.discount"
    class="user-input"
    min="0"
    placeholder="Inserisci sconto"
  />
  <h3>Totale: {{ totalWithDiscount.toFixed(2) }} €</h3>
</div>


          <div class="payment-method-section">
  <label for="paymentMethod">Metodo di pagamento:</label>
  <select id="paymentMethod" v-model="orderData.payment_method" class="user-input">
    <option value="custom_cash">Pagamento in Contanti</option>
    <option value="custom_card">Pagamento con Carta</option>
  </select>
</div>

          <button @click="handleOrder" :disabled="!userFound" class="create-user-button_blu staff-button-positive">
            <span class="material-icons">shopping_cart</span>
            Piazza Ordine
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>




<script>
import SidebarComponent from "../SidebarComponent.vue";
import axios from "axios";
import { getFirestore, collection, getDocs, setDoc, doc, query, where, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useRouter } from 'vue-router';
import { buildTopSkuFields } from '@/lib/topSku';


export default {
  components: {
    SidebarComponent,
  },
setup () {
  const router = useRouter();

  const goToSpesa = () => {
      router.push('/uscite');
    };

    return {
      goToSpesa,
    }
},



  data() {
    return {
      searchEmail: "", // Email per cercare il cliente
      products: [], // Lista dei prodotti da Firebase
      orders: [], // Lista degli ordini associati all'utente autenticato
      filteredOrders: [], // Ordini filtrati (popolati solo al click su "Cerca")

      userFound: false, // Stato del cliente trovato
      filtroData: {
        inizio: null,
        fine: null,
      }, // Filtri per data
      orderData: {
        customer_name: "",
        customer_surname: "",
        email: "",
        phone: "",
        codFiscale: "",
        indirizzo: "",
        cap: "",
        comune: "",
        regione: "",
        provincia: "",
        studio: "",
        notes: "",
        products: [
          {
            search: "",
            filteredProducts: [],
            product_id: null,
            quantity: 1,
          },
        ],
        discount: 0, // Sconto in euro
        payment_method: "custom_cash", // Metodo di pagamento predefinito
        uid: "", // UID dell'utente autenticato
        fonte: "studio", // Campo statico
      },
    };
  },

  computed: {
  // Calcola il totale dell'ordine con lo sconto applicato
  totalWithDiscount() {
    const total = this.orderData.products.reduce((sum, product) => {
      const selectedProduct = this.products.find((p) => p.id === product.product_id);
      const productPrice = selectedProduct ? selectedProduct.price : 0;
      return sum + productPrice * product.quantity;
    }, 0);

    const discount = this.orderData.discount || 0; // Assicurati che lo sconto sia un numero valido
    return Math.max(total - discount, 0); // Evita totali negativi
  },
},


  methods: {



    
    // Formatta la data in formato gg/mm/aaaa
    formatDate(date) {
      if (!date) return "";
      const giorno = date.getDate().toString().padStart(2, "0");
      const mese = (date.getMonth() + 1).toString().padStart(2, "0");
      const anno = date.getFullYear();
      return `${giorno}/${mese}/${anno}`;
    },



  filtraOrdini() {
    const { inizio, fine } = this.filtroData;

    if (!inizio || !fine) {
      alert("Inserisci sia la data di inizio che quella di fine!");
      return;
    }

    // Convertiamo le date inizio e fine in oggetti Date per il confronto
    const startDate = new Date(inizio);
    const endDate = new Date(fine);
    endDate.setHours(23, 59, 59, 999); // Include l'intera giornata finale

    // Filtra gli ordini basandosi sulle date
    this.filteredOrders = this.orders.filter((order) => {
      const orderDate = new Date(order.created_at);
      return orderDate >= startDate && orderDate <= endDate;
    });
  },




  async fetchOrdersForUid() {
  const db = getFirestore();
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    console.error("Utente non autenticato.");
    return;
  }

  try {
    const ordersQuery = query(
      collection(db, "orders"),
      where("uid", "==", currentUser.uid)
    );
    const querySnapshot = await getDocs(ordersQuery);

    this.orders = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        customer_name: data.billing.first_name || "N/A",
        customer_surname: data.billing.last_name || "N/A",
        total_without_discount: data.total_without_discount || 0,
        total_with_discount: data.total_with_discount || 0,
        created_at: new Date(data.created_at),
      };
    });

    this.filteredOrders = this.orders; // Imposta la lista iniziale
  } catch (error) {
    console.error("Errore durante il recupero degli ordini:", error);
  }
},






    // Recupera il prezzo di un prodotto basandosi sull'ID
    getProductPrice(productId) {
      const product = this.products.find((prod) => prod.id === productId);
      return product ? product.price : 0;
    },




    async addNewProducts() {
  const db = getFirestore();
  const url = "https://www.fusco.fit/wp-json/wc/v3/products";
  const auth = {
    username: "ck_ce3712505321aad959a770fb4cae554307b36bec",
    password: "cs_73e7f29a1dd6e2b83e697127afe423cbd3d95864",
  };

  try {
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await axios.get(url, {
        auth,
        params: { per_page: 100, page, status: "any" },
      });

      const products = response.data;

      for (const product of products) {
        const productRef = doc(db, "products", product.id.toString());
        const productSnapshot = await getDoc(productRef);

        // Aggiungi solo se il prodotto non esiste già
        if (!productSnapshot.exists()) {
          const productData = {
            id: product.id,
            name: product.name,
            price: parseFloat(product.price) || 0,
            description: product.description || "",
            categories: product.categories.map((cat) => cat.name),
            images: product.images.map((img) => img.src),
            visibility: product.status === "draft" ? false : true, // visibilità iniziale
          };

          await setDoc(productRef, productData);
          console.log(`Nuovo prodotto aggiunto: ${product.name}`);
        }
      }

      if (products.length < 100) {
        hasMore = false;
      } else {
        page += 1;
      }
    }

    alert("Nuovi prodotti aggiunti con successo!");
    this.fetchProductsFromFirebase(); // Aggiorna la lista dei prodotti
  } catch (error) {
    console.error("Errore durante l'aggiunta dei nuovi prodotti:", error);
    alert("Errore durante l'aggiunta dei nuovi prodotti.");
  }
},



    async syncProducts() {
  const db = getFirestore();
  const url = "https://www.fusco.fit/wp-json/wc/v3/products";
  const auth = {
    username: "ck_ce3712505321aad959a770fb4cae554307b36bec",
    password: "cs_73e7f29a1dd6e2b83e697127afe423cbd3d95864",
  };

  try {
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await axios.get(url, {
        auth,
        params: { per_page: 100, page, status: "any" }, // Include tutti i prodotti
      });

      const products = response.data;

      for (const product of products) {
        const productRef = doc(db, "products", product.id.toString());
        const productSnapshot = await getDoc(productRef);

        // Verifica la data di modifica
        const firebaseData = productSnapshot.exists() ? productSnapshot.data() : {};
        const firebaseDate = firebaseData.last_synced || "1970-01-01T00:00:00";

        // Aggiorna solo se il prodotto è nuovo o modificato
        if (new Date(product.date_modified) > new Date(firebaseDate)) {
          const productData = {
            id: product.id,
            name: product.name,
            price: parseFloat(product.price) || 0,
            description: product.description || "",
            categories: product.categories.map((cat) => cat.name),
            images: product.images.map((img) => img.src),
            visibility: product.status === "draft" ? false : true, // Imposta visibilità
            last_synced: product.date_modified, // Salva la data di ultima modifica
          };

          await setDoc(productRef, productData);
          console.log(`Prodotto aggiornato: ${product.name}`);
        }
      }

      if (products.length < 100) {
        hasMore = false;
      } else {
        page += 1;
      }
    }

    alert("Prodotti aggiornati con successo!");
    this.fetchProductsFromFirebase();
  } catch (error) {
    console.error("Errore durante la sincronizzazione dei prodotti:", error);
    alert("Errore durante la sincronizzazione dei prodotti.");
  }
},




    // Carica i prodotti da Firebase
    async fetchProductsFromFirebase() {
      const db = getFirestore();
      const productsCollection = collection(db, "products");

      try {
        const querySnapshot = await getDocs(productsCollection);
        this.products = querySnapshot.docs.map((doc) => doc.data());
      } catch (error) {
        console.error("Errore durante il recupero dei prodotti da Firebase:", error);
      }
    },

    // Aggiunge un prodotto all'ordine
    addProduct() {
  this.orderData.products.push({
    search: "",
    filteredProducts: this.products, // Array iniziale dei prodotti
    product_id: null, // ID del prodotto selezionato
    quantity: 1, // Quantità predefinita
  });
},


    // Filtra i prodotti in base alla ricerca
    filterProducts(index) {
  const search = this.orderData.products[index].search.toLowerCase();
  this.orderData.products[index].filteredProducts = this.products.filter(
    (product) => product.visibility && product.name.toLowerCase().includes(search)
  );
},



    // Cerca un cliente per email
    async fetchUserByEmail() {
      const db = getFirestore();
      const usersCollection = collection(db, "users");

      try {
        const userQuery = query(usersCollection, where("email", "==", this.searchEmail));
        const querySnapshot = await getDocs(userQuery);

        if (!querySnapshot.empty) {
const user = querySnapshot.docs[0].data();
          this.orderData.customer_name = user.name || "";
          this.orderData.customer_surname = user.surname || "";
          this.orderData.email = user.email || "";
          this.orderData.phone = user.phone || "";
          this.orderData.codFiscale = user.codFiscale || "";
          this.orderData.indirizzo = user.indirizzo || "";
          this.orderData.cap = user.cap || "";
          this.orderData.comune = user.comune || "";
          this.orderData.regione = user.regione || "";
          this.orderData.provincia = user.provincia || "";
          this.orderData.studio = user.studio || "";
          this.orderData.notes = user.notes || "";
          this.userFound = true;
          this.fetchOrdersForUid(); // Recupera gli ordini dell'utente trovato
        } else {
          alert("Cliente non trovato.");
          this.userFound = false;
        }
      } catch (error) {
        console.error("Errore durante la ricerca del cliente:", error);
        alert("Errore durante la ricerca del cliente.");
      }
    },


    // Rimuove una riga di prodotto
    removeProduct(index) {
      this.orderData.products.splice(index, 1);
    },


    
    async handleOrder() {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    this.orderData.uid = user.uid; // Recupera l'UID dell'utente autenticato
  } else {
    console.error("Utente non autenticato. Impossibile assegnare l'UID.");
    this.orderData.uid = "unknown";
  }

  const url = "https://www.fusco.fit/wp-json/wc/v3/orders";
  const authCredentials = {
    username: "ck_ce3712505321aad959a770fb4cae554307b36bec",
    password: "cs_73e7f29a1dd6e2b83e697127afe423cbd3d95864",
  };

  // Calcolo dei totali
const totalWithoutDiscount = this.orderData.products.reduce((sum, product) => {
  const selectedProduct = this.products.find((p) => p.id === product.product_id);
  return sum + (selectedProduct ? selectedProduct.price : 0) * product.quantity;
}, 0);

const discount = this.orderData.discount || 0; // Sconto totale applicato
const discountProportion = discount / totalWithoutDiscount;

let discountTax = 0; // Tasse sullo sconto
let taxTotal = 0; // Totale tasse applicate

// Generazione dei line_items
const lineItems = this.orderData.products.map((product) => {
  const selectedProduct = this.products.find((p) => p.id === product.product_id);
  const productPrice = selectedProduct ? selectedProduct.price : 0;
  const totalPrice = productPrice * product.quantity;

  // Determina se il prodotto è IVA 0% o IVA 22%
  const isTaxExempt = selectedProduct.tax_class === "zero";
  const taxRate = isTaxExempt ? 0 : 0.22;

  // Calcolo dello sconto e del prezzo scontato
  const discountForProduct = totalPrice * discountProportion;
  const discountedPrice = totalPrice - discountForProduct;

  if (!isTaxExempt) {
    const originalTax = totalPrice * (taxRate / (1 + taxRate));
    const discountedTax = discountedPrice * (taxRate / (1 + taxRate));
    discountTax += originalTax - discountedTax;
    taxTotal += discountedTax;
    return {
      product_id: product.product_id,
      quantity: product.quantity,
      subtotal: (totalPrice - originalTax).toFixed(2),
      subtotal_tax: originalTax.toFixed(2),
      total: (discountedPrice - discountedTax).toFixed(2),
      total_tax: discountedTax.toFixed(2),
      taxes: [{ id: 1, total: discountedTax.toFixed(2), subtotal: originalTax.toFixed(2) }],
    };
  } else {
    // Prodotto IVA esente
    return {
      product_id: product.product_id,
      quantity: product.quantity,
      subtotal: totalPrice.toFixed(2),
      subtotal_tax: "0.00",
      total: discountedPrice.toFixed(2),
      total_tax: "0.00",
      taxes: [],
    };
  }
});

// Payload aggiornato per WooCommerce
const orderPayload = {
  payment_method: this.orderData.payment_method,
  payment_method_title: "Pagamento con " + this.orderData.payment_method,
  set_paid: true,
  status: "completed",
  billing: {
    first_name: this.orderData.customer_name,
    last_name: this.orderData.customer_surname,
    email: this.orderData.email,
    phone: this.orderData.phone,
    address_1: this.orderData.indirizzo,
    city: this.orderData.comune,
    state: this.orderData.regione,
    postcode: this.orderData.cap,
    country: "IT",
  },
  line_items: lineItems,
  discount_total: (discount - discountTax).toFixed(2), // Sconto netto
  discount_tax: discountTax.toFixed(2), // Tasse scontate
  tax_lines: [
    {
      rate_id: 1,
      label: "Imposte",
      compound: false,
      tax_total: taxTotal.toFixed(2),
      shipping_tax_total: "0.00",
    },
  ],
  total: (totalWithoutDiscount - discount).toFixed(2), // Totale ordine finale
  meta_data: [
    { key: "_billing_cod_fisc", value: this.orderData.codFiscale },
    { key: "_billing_studio_PT", value: this.orderData.studio },
    { key: "_billing_notes", value: this.orderData.notes },
    { key: "_total_without_discount", value: totalWithoutDiscount.toFixed(2) },
    { key: "_custom_discount_applied", value: discount.toFixed(2) },
  ],
};

try {
  const response = await axios.post(url, orderPayload, {
    auth: authCredentials,
    headers: { "Content-Type": "application/json" },
  });

  const orderId = response.data.id;
  alert(`Ordine piazzato con successo! ID Ordine: ${orderId}`);

  // Salva su Firebase
  await this.saveOrderToFirebase(orderPayload, orderId);
} catch (error) {
  console.error("Errore durante il piazzamento dell'ordine:", error.response?.data || error.message);
  alert("Errore durante il piazzamento dell'ordine.");
}


    },


async saveOrderToFirebase(orderPayload, orderId) {
  const db = getFirestore();
  const ordersCollection = collection(db, "orders");



  // Calcola i totali
  const totalWithoutDiscount = this.orderData.products.reduce((sum, product) => {
    const selectedProduct = this.products.find((p) => p.id === product.product_id);
    const productPrice = selectedProduct ? selectedProduct.price : 0;
    return sum + productPrice * product.quantity;
  }, 0);

  const discount = this.orderData.discount || 0;
  const totalWithDiscount = totalWithoutDiscount - discount;

  const topSkuFields = buildTopSkuFields(orderPayload, { fallbackToNow: true });

  const orderData = {
    ...orderPayload,
    ...topSkuFields,
    order_id: orderId,
    uid: this.orderData.uid,
    fonte: this.orderData.fonte,
    created_at: new Date().toISOString(),
    discount: discount, // Lo sconto applicato
    total_without_discount: totalWithoutDiscount.toFixed(2), // Totale senza sconto
    total_with_discount: totalWithDiscount.toFixed(2), // Totale con sconto
  };

  try {
    await setDoc(doc(ordersCollection, orderId.toString()), orderData);
    console.log("Ordine salvato con successo su Firebase.");
  } catch (error) {
    console.error("Errore durante il salvataggio su Firebase:", error);
  }
}






  },

  mounted() {
    this.fetchProductsFromFirebase();
  this.fetchOrdersForUid().then(() => {
    const today = new Date().toISOString().split("T")[0]; // Data in formato YYYY-MM-DD
    this.filtroData.inizio = today;
    this.filtroData.fine = today;
    this.filtraOrdini(); // Applica il filtro per "oggi"
  });
},
};
</script>



<style scoped>
.product-row {
  display: flex; /* Usa Flexbox */
  gap: 10px; /* Spaziatura tra elementi */
  align-items: center; /* Allineamento verticale centrato */
  margin-bottom: 10px;
}

.product-select {
  flex: 2; /* La select occupa più spazio */
}

.quantity-container {
  flex: 1; /* Il campo Quantità occupa meno spazio */
  display: flex;
  align-items: center; /* Allinea label e input verticalmente */
  gap: 5px; /* Spaziatura tra label e input */
}

.product-quantity {
  width: 60px; /* Larghezza specifica per il campo quantità */
}

.filter-button {
  margin-left: 10px;
  padding: 10px 15px;
  background-color: #c1c1c1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.filter-button:hover {
  background-color: #45a049;
}


.filter-container {
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.filter-container input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}



.content-container {
  position: relative;
flex-grow: 1;
padding: 100px 20px 0 var(--staff-content-inset, 297px);
overflow-y: auto;
max-width: 97%;
transition: padding-left 0.3s;
}


.columns-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 100px;
}

.column {
  flex: 1;
  background-color: #f9f9f9;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  min-width: 100px;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
}

.orders-table th,
.orders-table td {
  padding: 0.5rem;
  border: 1px solid #ddd;
}

.orders-table thead {
  background-color: #c1c1c1;
  color: white;
}



/* Layout generale */
.dashboard-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}




/* Titolo */


/* Campi di ricerca */
.search-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  margin-top: 10px;
}

.search-field {
  flex: 1;
}

.search-bar {
  width: 94%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
}

/* Bottoni */
.create-user-button_blu {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 1rem;
  cursor: pointer;
  
}

.create-user-button span {
  margin-right: 8px;
}

.create-user-button:hover {
  background-color: #0056b3;
}

/* Dati Cliente */
.data-section p {
  margin: 5px 0;
  font-size: 1rem;
}

/* Sezione Prodotti */
.product-section {
  margin-top: 20px;
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

.user-input {
  width: 50%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Totali */
.totals-section h3 {
  font-size: 23px;
  font-weight: bold;
  color: #008d28;
  text-align: left;
  margin-top: 10px;
}

.totals-section {
  margin-top: 50px;
}

</style>
